/**
 * Cryptography Utilities
 *
 * Utilities for encryption and decryption using CryptoJS
 */

import { getEnv } from '@shared/utils/env';
import CryptoJS from 'crypto-js';

/**
 * Encrypt an object using AES encryption
 */
export function encryptObject(data: Record<string, any>): string {
  const jsonString = JSON.stringify(data);
  const secretKey = getEnv().VITE_ENCRYPTION_KEY;
  return CryptoJS.AES.encrypt(jsonString, secretKey).toString();
}

/**
 * Decrypt an object from AES encrypted string
 */
export function decryptObject(data: string): Record<string, any> {
  try {
    const secretKey = getEnv().VITE_ENCRYPTION_KEY;
    const decryptedString = CryptoJS.AES.decrypt(data, secretKey).toString(CryptoJS.enc.Utf8);

    if (!decryptedString) {
      return JSON.parse(data);
    }

    return JSON.parse(decryptedString);
  } catch (error) {
    try {
      return JSON.parse(data);
    } catch {
      console.error('Error decrypting object', error);
      throw new Error('Failed to decrypt data');
    }
  }
}
